import { render, staticRenderFns } from "./PersianCalendar.vue?vue&type=template&id=e14308d4&"
import script from "./PersianCalendar.vue?vue&type=script&lang=js&"
export * from "./PersianCalendar.vue?vue&type=script&lang=js&"
import style0 from "./PersianCalendar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports